import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../../Icon';
import styles from './MemoryTabs.css';

const cx = classnames.bind(styles);

function MemoryTabs({ options, value, onChange }) {
    return (
        <div
            className={styles.root}
            role='group'
            aria-label='Memory views'
        >
            {options.map((option) => (
                <button
                    key={option.type}
                    type='button'
                    aria-pressed={option.type === value}
                    className={cx('tab', { active: option.type === value })}
                    data-tour={option.tourTarget}
                    onClick={() => onChange(option.type)}
                >
                    <Icon name={option.iconName} className={styles.icon} />
                    <span className={styles.label}>{option.label}</span>
                </button>
            ))}
        </div>
    );
}

MemoryTabs.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        iconName: PropTypes.string.isRequired,
        tourTarget: PropTypes.string
    })).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export {
    MemoryTabs
};
